import { observable, action } from 'mobx';
import GlobalMetaTagsService from 'services/GlobalMetaTags.service';

class GlobalMetaTagsStore {
  @observable metaTags = null;

  constructor() {
    this.getMetaTagsData();
  }

  @action
  async getMetaTagsData() {
    try {
      this.metaTags = await GlobalMetaTagsService.fetchMetaTagsData();
    } catch (e) {
      throw e;
    }
  }
}

export default GlobalMetaTagsStore;



// WEBPACK FOOTER //
// ./src/stores/GlobalMetaTags.store.js